import { HttpError } from 'react-admin';
import { authTokenStore } from './authTokenStore';

const parseResponse = (response: string) => {
  try {
    return JSON.parse(response);
  } catch {
    return undefined;
  }
};

const uploadDocument = (
  url: string,
  files: { fileName: string; file: File }[],
) => new Promise((resolve, reject) => {
  const formData = new window.FormData();
  files.forEach(({ fileName, file }) => {
    formData.append(fileName, file);
  });

  const request = new window.XMLHttpRequest();

  request.open('POST', url);
  request.setRequestHeader('authorization', `Bearer ${authTokenStore.getToken()}`);
  request.onload = () => {
    const body = parseResponse(request.response);
    if (request.status >= 400 || body === undefined) {
      reject(new HttpError(body?.message || request.statusText || 'Could not upload the file', request.status, body));
    } else {
      resolve(body);
    }
  };
  request.onerror = () => reject(new HttpError('Could not upload the file', 0));
  request.onabort = () => reject(new HttpError('The upload was cancelled', 0));

  request.send(formData);
});

export default uploadDocument;
